export default {
  es: {
    'app.home.index.alert.historical': 'Existen unos datos historicos de {historico, number} inmuebles vendidos o reservados y {reservadas, number} reservas.',
    'app.home.index.btn.historical-display': 'Descontar histórico y reservas de las ventas',
    'app.home.index.btn.historical-hide': 'Aplicar histórico y reservas a las ventas',
    'app.home.index.count': 'Total',
    'app.home.index.counts.libres': 'Viviendas libres',
    'app.home.index.counts.reservadas': 'Viviendas reservadas',
    'app.home.index.counts.totales': 'Viviendas',
    'app.home.index.counts.vendidas': 'Viviendas vendidas',
    'app.home.index.desde': 'Fecha inicio',
    'app.home.index.estatus': 'Estado',
    'app.home.index.hasta': 'Fecha fin',
    'app.home.index.header.stats.comerciales': 'Visitas por comercial',
    'app.home.index.header.stats.conociste': 'Cómo nos han conocido',
    'app.home.index.header.stats.counts': 'Venta de viviendas',
    'app.home.index.header.stats.promociones': 'Visitas por promoción',
    'app.home.index.logotipo': 'Logotipo construcciones Andia',
    'app.home.index.medio': 'Medio',
    'app.home.index.promocion': 'Promoción',
    'app.home.index.select-promociones-all': 'Todas las promociones',
    'app.home.index.select.month': 'Último mes',
    'app.home.index.select.since': 'Rango temporal:',
    'app.home.index.select.week': 'Última semana',
    'app.home.index.select.year': 'Último año',
    'app.home.index.status-promociones': 'Status',
    'app.home.index.table.col.cantidad': 'Cantidad',
    'app.home.index.table.col.name': 'Tipo',
    'app.home.index.table.col.percent': '%',
    'app.home.index.table.col.vendidas': 'Ventas',
    'app.home.index.title': 'Panel de administración',
    'app.home.index.ventas': 'Ventas',
    'app.home.index.visita': 'Visita',
  },
};